import React from 'react'
import Input from './../input'
import { PROTOCOL } from './../../lib/helper'
import { Form } from 'formsy-react'
import _ from 'underscore'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class WPEngineForm extends React.Component {
	constructor(props){
		super(props)
		this.state = {sourceSiteInfo: false, tablesInfo: false}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.togglePrivacyMode = this.togglePrivacyMode.bind(this)
		this.toggleSourceSiteInfo = this.toggleSourceSiteInfo.bind(this)
		this.toggleTablesInfo = this.toggleTablesInfo.bind(this)
		this.toggleHttpAuth = this.toggleHttpAuth.bind(this)
		this.showDirectoryList = this.showDirectoryList.bind(this)
		this.showTablesList = this.showTablesList.bind(this)
	}

	componentDidMount(){
		const { actions, history, migrate } = this.props
		if (!migrate.get('errors').size) {
			actions.openModal({name: 'WPEMigReadinessModal', history: history, migrate: migrate})
		}
	}

	UNSAFE_componentWillMount(){
		this.setToggle()
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	setToggle() {
		const { fields } = this.props
		if (fields['selectedDirectories'] && !_.isEmpty(fields['selectedDirectories'])) {
			this.setState({sourceSiteInfo: true})
		}
		if (fields['selectedTables'] && !_.isEmpty(fields['selectedTables'])) {
			this.setState({tablesInfo: true})
		}
	}

	togglePrivacyMode() {
		const { privacyMode } = this.state
		this.setState({privacyMode: !privacyMode})
	}

	toggleSourceSiteInfo() {
		const { sourceSiteInfo } = this.state
		this.setState({sourceSiteInfo: !sourceSiteInfo})
	}

	toggleTablesInfo() {
		const { tablesInfo } = this.state
		this.setState({tablesInfo: !tablesInfo})
	}

	toggleHttpAuth() {
		const { httpAuth } = this.state
		this.setState({httpAuth: !httpAuth})
	}

	showDirectoryList() {
		const { directoryList, changeSelection } = this.props
		if (directoryList){
			return directoryList.map((directory, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className={`control control--checkbox ${directory.isDisabled ? 'disabled' : ''}`}>{directory.name}
						<input
							name={directory.name}
							type="checkbox"
							checked={directory.selected}
							onChange={changeSelection.bind(null, directory.name)}
							disabled={directory.isDisabled}
						/>
						<div className="control__indicator"></div>
					</label>
				</li>
			})
		}
	}

	showTablesList() {
		const { tablesList, changeTableSelection } = this.props
		if (tablesList) {
			return tablesList.map((table, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className={`control control--checkbox ${table.isDisabled ? 'disabled' : ''}`}>{table.name}
						<input
							name={table.name}
							type="checkbox"
							checked={table.selected}
							onChange={changeTableSelection.bind(null, table.name)}
							disabled={table.isDisabled}
						/>
						<div className="control__indicator"></div>
					</label>
				</li>
			})
		}
	}

	render() {
		const { handleSubmit, error, getDirectoryList, fetchingDirectories, history, getTablesList, fetchingTables } = this.props
		const { privacyMode, sourceSiteInfo, tablesInfo, httpAuth } = this.state
		return <div className="wpe">
			<div className="body no-touchevents">
				<div className="container-fluid">
					<div className="row justify-content-center">
						<div className="col-sm-6 float-none margin-auto">
							<h1 className="mt-1">Migrate my site to WP Engine</h1>
						</div>
					</div>
				</div>
				<div className="container-fluid">
					<div className="row justify-content-center">
						<div className="col-sm-6 float-none margin-auto">
							<p className="subhead">The WP Engine Automated Migration plugin allows you to easily migrate your entire WordPress
								{' '}site from your previous hosting service to WP Engine for free.
								{' '}For full instructions and solutions to common errors, please visit our {' '}
								<a href="https://wpengine.com/support/wp-engine-automatic-migration-powered-by-blogvault/" target="_blank" rel="noreferrer">
									WP Engine Automated Migration support garage article.
								</a>
							</p>
							<p className="subhead">
								Take the information from the migration page of your WP Engine User Portal, and paste those values into the fields below.
							</p>
						</div>
					</div>
				</div>

				<Form className="needs-validation form" onSubmit={handleSubmit}>
					<div className="container-fluid">
						<div className="row justify-content-center">
							<div className="col-sm-6 float-none margin-auto">
								<div className="row justify-content-center">
									{ error && <div className="pb-2 font12 col-sm-12 text-center">{error}</div> }
									<div className="col-sm-12 p-0">
										<div className="col-sm-6">
											<div className="row">
												<div className={this.getClassName('newurl')}>
													<Input
														type="text"
														name="newurl"
														title="Destination Site URL"
														classname=""
														value={this.fetchValue('newurl')}
													/>
												</div>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="row">
												<div className={this.getClassName('address')}>
													<Input
														type="text"
														name="address"
														title="SFTP host/server address"
														classname=""
														value={this.fetchValue('address')}
													/>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-12 p-0">
										<div className="col-sm-6">
											<div className="row">
												<div className={this.getClassName('username')}>
													<Input
														type="text"
														name="username"
														title="SFTP Username"
														classname=""
														value={this.fetchValue('username')}
													/>
												</div>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="row">
												<div className={this.getClassName('passwd')}>
													<Input
														type="password"
														name="passwd"
														title="SFTP Password"
														classname=""
														value={this.fetchValue('passwd')}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row justify-content-center">
									<div className="col-sm-6 pt-1">
										<div className="row v-center">
											<div className="col-sm-9">
												<p>There are root directories I want to migrate.</p>
											</div>
											<div className="col-sm-3">
												<span className="float-right">
													<div className="custom-control custom-checkbox">
														<label className="control control--checkbox" style={{margin: 'unset'}}>
															<span className="tooltip">
																&nbsp;<img src="/assets/wpengine/help.svg" className="tooltip__trigger" alt=""/>
																<div className="tooltip__body">
																	By default, the plugin only moves the database and files found in the wp-content directory.
																	&nbsp;If you have any directories in the site root that also need to be moved over, select those.
																</div>
															</span>
															<input name="sourceSiteInfo" type="checkbox" checked={sourceSiteInfo} onClick={getDirectoryList}
																onChange={this.toggleSourceSiteInfo}
															/>
															<div className="control__indicator"></div>
														</label>
													</div>
												</span>
											</div>
										</div>
										<div className="mb-3 source-site-info-container">
											{fetchingDirectories && <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading…"/>}
											{sourceSiteInfo && this.showDirectoryList()}
										</div>
									</div>
								</div>
								<div className="row justify-content-center">
									<div className="col-sm-6 pt-1">
										<div className="row v-center">
											<div className="col-sm-9">
												<p>Migrate additional database tables.</p>
											</div>
											<div className="col-sm-3">
												<span className="float-right">
													<div className="custom-control custom-checkbox">
														<label className="control control--checkbox" style={{margin: 'unset'}}>
															<span className="tooltip">
																&nbsp;<img src="/assets/wpengine/help.svg" className="tooltip__trigger" alt=""/>
																<div className="tooltip__body">
																	By default, this plugin only moves the database and files found in the wp-content directory.
																	&nbsp;If you would like to bring over additional database tables that have transient data or plugin configurations (ex. caching information), select the additional tables below.
																	&nbsp;This is not recommended for most WordPress installs as it can corrupt / bloat the destination environment.
																</div>
															</span>
															<input name="tablesInfo" type="checkbox" checked={tablesInfo} onClick={getTablesList}
																onChange={this.toggleTablesInfo}
															/>
															<div className="control__indicator"></div>
														</label>
													</div>
												</span>
											</div>
										</div>
										<div className="mb-3 tables-info-container">
											{fetchingTables && <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading…"/>}
											{tablesInfo && this.showTablesList()}
										</div>
									</div>
								</div>
								<div className="row justify-content-center blue-background">
									<div className="col-sm-12 py-2">
										<h1>Password protection details </h1>						
										If your current host or your WP Engine install is password protected, you&apos;ll need to enter
										{' '}that information here so that the migration plugin can access all of your site.
										<div className="col-sm-12 p-0">
											<h2 className="mr-1" style={{display: 'inline-block'}}>Site is password protected at current host</h2>
											<input type="radio" id="source-pm-enabled-yes" name="source-pm-enabled" checked={httpAuth} onChange={this.toggleHttpAuth}/>
											<label className="radio" htmlFor="source-pm-enabled-yes">Yes</label>
											<input type="radio" data-hide-next id="source-pm-enabled-no" name="source-pm-enabled" checked={!httpAuth} onChange={this.toggleHttpAuth}/>
											<label htmlFor="source-pm-enabled-no">No</label>
											<div data-toggle-section>
												<div className="col-sm-6 pl-0">
													<div className="row">
														<div className={this.getClassName('httpauth_src_user')}>
															<Input
																type="text"
																name="httpauth_src_user"
																title="User"
																id="source-pm-username"
																value={this.fetchValue('httpauth_src_user')}
															/>
														</div>
													</div>
												</div>
												<div className="col-sm-6 pr-0">
													<div className="row">
														<div className={this.getClassName('httpauth_src_password')}>
															<Input
																type="password"
																title="Password"
																name="httpauth_src_password"
																id="source-pm-password"
																value={this.fetchValue('httpauth_src_password')}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-sm-12 p-0">
											<h2 className="mr-2" style={{display: 'inline-block'}}>Site is password protected at WP Engine&nbsp;</h2>
											<input type="radio" id="wpe-pm-enabled-yes" name="wpe-pm-enabled" checked={privacyMode} onChange={this.togglePrivacyMode}/>
											<label htmlFor="wpe-pm-enabled-yes">Yes</label>
											<input type="radio" data-hide-next id="wpe-pm-enabled-no" name="wpe-pm-enabled" checked={!privacyMode} onChange={this.togglePrivacyMode}/>
											<label htmlFor="wpe-pm-enabled-no">No</label>
											<div data-toggle-section>
												<div className="col-sm-6 pl-0">
													<div className="row">
														<div className={this.getClassName('httpauth_dest_user')}>
															<Input
																type="text"
																name="httpauth_dest_user"
																title="User"
																id="wpe-pm-username"
																value={this.fetchValue('httpauth_dest_user')}
															/>
														</div>
													</div>
												</div>
												<div className="col-sm-6 pr-0">
													<div className="row">
														<div className={this.getClassName('httpauth_dest_password')}>
															<Input
																type="password"
																title="Password"
																name="httpauth_dest_password"
																id="wpe-pm-password"
																value={this.fetchValue('httpauth_dest_password')}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row hide-field">
									<Input
										type="hidden"
										name="migrate"
										value="wpengine"
										title=""
										placeholder=""
										classname=""
									/>
									<Input
										type="hidden"
										title=""
										name="type"
										placeholder=""
										classname=""
										value="sftp"
									/>
									<Input
										type="hidden"
										title=""
										name="protocol"
										placeholder=""
										classname=""
										value={PROTOCOL.SFTP}
									/>
								</div>
								<div className="row justify-content-center mt-3 no-gutters">
									<div className="col-sm-6 col-sm-offset-6">
										<button type="submit" className="button migrate-button width33 align-right">Migrate</button>
										<a onClick={history.goBack} className="button cancel-button align-right">Cancel</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Form>
			</div>
		</div>
	}
}

WPEngineForm.propTypes = {
	actions: PropTypes.object, 
	history: PropTypes.object, 
	migrate: ImmutablePropTypes.map,
	handleSubmit: PropTypes.func,
	fields: PropTypes.object,
	errors: PropTypes.array,
	error: PropTypes.object,
	directoryList: PropTypes.array,
	changeSelection: PropTypes.func,
	getDirectoryList: PropTypes.func,
	fetchingDirectories: PropTypes.bool
}

export default WPEngineForm
